/* eslint-disable @typescript-eslint/no-unused-vars */
import { Component } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';

import { setLoading } from 'src/app/redux/actions/user.actions';
import { AppState } from 'src/app/redux/app.state';
import { NotificationService } from 'src/app/services/notification.service';
import { SupportService } from 'src/app/support.service';
import { ConfirmComponent } from 'src/app/support/confirm/confirm.component';
import { CarModelType, Engine, InfoRow, User } from 'src/typings';
import { AddInfoRowComponent } from '../add-info-row/add-info-row.component';
import { CarModelTypeService } from '../car-model-type.service';

@Component({
  selector: 'app-profile-info',
  templateUrl: './profile-info.component.html',
  styleUrls: ['./profile-info.component.scss']
})
export class ProfileInfoComponent {
  set car(car: CarModelType) {
    this._car = car;
    this.profileForm.controls.description.setValue(this._car.description);
    this.profileForm.controls.manufacture_date_from.setValue(this._car.manufacture_date_from);
    this.profileForm.controls.manufacture_date_to.setValue(this._car.manufacture_date_to);
    this.profileForm.controls.engines.setValue(this._car.engines);
    if (car.info_row) this.info = car.info_row;
  }

  info: InfoRow[] = [];

  _car: CarModelType | undefined;

  user: User | undefined;

  set loading(value: boolean) {
    this.store.dispatch(setLoading({ payload: value }));
  }

  profileForm = this.fb.group({
    description: new UntypedFormControl(),
    manufacture_date_from: new UntypedFormControl(),
    manufacture_date_to: new UntypedFormControl(),
    engines: new UntypedFormControl()
  });

  columnsToDisplay = ['description', 'value', 'action'];

  get enginesControl() {
    return this.profileForm.controls.engines as UntypedFormControl;
  }

  constructor(
    private carService: CarModelTypeService,
    private activateRoute: ActivatedRoute,
    private dialog: MatDialog,
    private fb: UntypedFormBuilder,
    private store: Store<AppState>,
    public supportService: SupportService,
    private notificationService: NotificationService
  ) {
    this.activateRoute.params.subscribe((params) => {
      this.updateInfoCar(params.id);
    });
    this.store.subscribe((data) => {
      this.user = data.user.info;
    });
  }

  updateInfoCar(id: number) {
    this.loading = true;
    this.carService.getOne(id).subscribe((car) => {
      this.car = car;
      this.loading = false;
    });
  }

  getEngineDescription() {
    return this._car?.engines.map((engine) => engine.description).join(', ');
  }

  getHorsePower() {
    return `${this._car?.engines[0].horsePower} л.с. ${this._car?.engines[0].kW} кВт`;
  }

  save() {
    if (!this._car) return;
    this.carService
      .update({
        id: this._car.id,
        description: this.profileForm.value.description,
        manufacture_date_from: this.profileForm.value.manufacture_date_from,
        manufacture_date_to: this.profileForm.value.manufacture_date_to,
        engineIds: this.profileForm.value.engines.map((engine: Engine) => engine.id)
      })
      .subscribe((car) => {
        this.updateInfoCar(car.id);
        this.notificationService.notice(`Информация сохранена!`);
      });
  }

  sortData(event: any) {
    // this.sort_active = event.active;
    // this.sort_direction = event.direction;
    // if (this.paginator) this.paginator.pageIndex = 0;
    // this.searchByPage();
  }

  searchByPage(page = 0) {
    // if (!this.user || !this.selectedFolder) return;
    // this.loading = true;
    // this.productService
    //   .search({
    //     default_warehouse_id: this.user.defaultWarehouse.id,
    //     folders_id: [this.selectedFolder.id],
    //     car_id: this.car?.id,
    //     limit: this.pageSize,
    //     offset: page * this.pageSize,
    //     sort_active: this.sort_active,
    //     sort_direction: this.sort_direction
    //   })
    //   .subscribe((data) => {
    //     this.loading = false;
    //     this.tableProducts = data.data;
    //     this.resultsLength = data.length;
    //   });
  }

  addinfoRow() {
    if (!this._car) return;
    const dialogRef = this.dialog.open(AddInfoRowComponent);
    dialogRef.componentInstance.car_id = this._car.id;
    dialogRef.componentInstance.changeEvent.subscribe(() => {
      if (!this._car) return;
      this.updateInfoCar(this._car.id);
      dialogRef.close();
    });
  }

  editInfoRow(infoRow: InfoRow) {
    if (!this._car) return;
    const dialogRef = this.dialog.open(AddInfoRowComponent);
    dialogRef.componentInstance.car_id = this._car.id;
    dialogRef.componentInstance.row_id = infoRow.id;
    dialogRef.componentInstance.description = infoRow.description;
    dialogRef.componentInstance.value = infoRow.value;
    dialogRef.componentInstance.changeEvent.subscribe(() => {
      if (!this._car) return;
      this.updateInfoCar(this._car.id);
      this.notificationService.notice(`Строка информации сохранена!`);
      dialogRef.close();
    });
  }

  deleteInfoRow(id: number) {
    if (!this._car) return;
    this.loading = true;
    this.carService.removeInfoRow(id).subscribe(
      () => {
        if (!this._car) return;
        this.loading = false;
        this.notificationService.notice(`Строка информации удалена!`);
        this.updateInfoCar(this._car.id);
      },
      (err) => {
        this.loading = false;
        this.notificationService.warning(err.message);
      }
    );
  }

  confirmDialog(infoRow: InfoRow) {
    const dialogRef = this.dialog.open(ConfirmComponent);
    dialogRef.componentInstance.confirmEvent.subscribe((value) => {
      if (value === true) this.deleteInfoRow(infoRow.id);
      dialogRef.close();
    });
  }
}
